import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../src/navbar';
import contactus from '../../../src/contactus.webp';
import { productsService } from '../../services/api/products.service';

function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const data = await productsService.getAllCategories();
        setCategories(Array.isArray(data) ? data : []);
      } catch (err) {
        setError((err && (err.message || err.error)) || String(err));
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return (
    <>
      <div className="flex">
        <Navbar />
      </div>
      <div className="max-w-6xl mx-auto p-4 mt-20">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">Categories</h1>
          <Link to="/categories/add" className="bg-blue-600 text-white px-4 py-2 rounded">Add Category</Link>
        </div>

        {loading && <div className="text-center">Loading...</div>}
        {error && <div className="text-red-600">{error}</div>}

        {!loading && !error && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {categories.map((cat) => (
              <div key={cat._id} className="border rounded overflow-hidden">
                <Link to={`/categories/${cat._id}/products`}>
                  <img src={`/${cat.image}`} alt={cat.name} className="w-full h-40 object-cover" />
                </Link>
                <div className="p-4 flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold">{cat.name}</h3>
                    {cat.description && <p className="text-sm text-gray-600">{cat.description}</p>}
                  </div>
                  <div className="space-x-2">
                    <Link to={`/categories/edit/${cat._id}`} className="text-blue-600">Edit</Link>
                    <Link to={`/categories/delete/${cat._id}`} className="text-red-600">Delete</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default CategoryList;
